import property1 from '../assect/images/property/1.jpg'
import property2 from '../assect/images/property/2.jpg'
import property3 from '../assect/images/property/3.jpg'
import property4 from '../assect/images/property/4.jpg'
import property5 from '../assect/images/property/5.jpg'
import property6 from '../assect/images/property/6.jpg'
import property7 from '../assect/images/property/7.jpg'
import property8 from '../assect/images/property/8.jpg'
import property9 from '../assect/images/property/9.jpg'

import client1 from '../assect/images/client/01.jpg'
import client2 from '../assect/images/client/02.jpg'
import client3 from '../assect/images/client/03.jpg'
import client4 from '../assect/images/client/04.jpg'
import client5 from '../assect/images/client/05.jpg'
import client6 from '../assect/images/client/06.jpg'
import client7 from '../assect/images/client/07.jpg'


export const propertyData = [
    {
        id:1,
        image: property1,
        title: '10765 Hillshire Ave, Baton Rouge, LA 70810, USA',
    },
    {
        id:2,
        image: property2,
        title: '59345 STONEWALL DR, Plaquemine, LA 70764, USA',
    },
    {
        id:3,
        image: property3,
        title: '3723 SANDBAR DR, Addis, LA 70710, USA',
    },
    {
        id:4,
        image: property4,
        title: 'Lot 21 ROYAL OAK DR, Prairieville, LA 70769, USA',
    },
    {
        id:5,
        image: property5,
        title: '710 BOYD DR, Unit #1102, Baton Rouge, LA 70808, USA',
    },
    {
        id:6,
        image: property6,
        title: '5133 MCLAIN WAY, Baton Rouge, LA 70809, USA',
    },
    {
        id:7,
        image: property7,
        title: '1574 Sharlo Ave, Baton Rouge, LA 70820, USA',
    },
    {
        id:8,
        image: property8,
        title: '2528 BOCAGE LAKE DR, Baton Rouge, LA 70809, USA',
    },
    {
        id:9,
        image: property9,
        title: '1533 NICHOLSON DR, Baton Rouge, LA 70802, USA',
    },
]

export const clientData = [
    {
        image: client1,
        name: 'Young Bonetti',
        title: 'Product Manager',
        desc: '" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text. "'
    },
    {
        image: client2,
        name: 'Ofelia Bell',
        title: 'Product Manager',
        desc: '" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text. "'
    },
    {
        image: client3,
        name: 'Barbara Carpenter',
        title: 'Product Manager',
        desc: '" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text. "'
    },
    {
        image: client4,
        name: 'Jesus Day',
        title: 'Product Manager',
        desc: '" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text. "'
    },
    {
        image: client5,
        name: 'Jennifer Smith',
        title: 'Product Manager',
        desc: '" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text. "'
    },
    {
        image: client6,
        name: 'Michael Wilkes',
        title: 'Product Manager',
        desc: '" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. One may speculate that over the course of time certain letters were added or deleted at various positions within the text. "'
    },
]

export const brokerData = [
    {
        image: client4,
        name: 'Jack John',
        title: 'Broker'
    },
    {
        image: client5,
        name: 'Krista John',
        title: 'Broker'
    },
    {
        image: client6,
        name: 'Roger Jackson',
        title: 'Broker'
    },
    {
        image: client7,
        name: 'Johnny English',
        title: 'Broker'
    },
]

export const blogData = [
    {
        id:1,
        image: property1,
        tag:'Townter',
        title:'Skills That You Can Learn In The Real Estate Market',
        desc:"The most well-known dummy text is the 'Lorem Ipsum', in the 16th century.",
        date:'13th Sep 2023'
    },
    {
        id:2,
        image: property2,
        tag:'Townter',
        title:'Learn The Truth About Real Estate Industry',
        desc:"The most well-known dummy text is the 'Lorem Ipsum', in the 16th century.",
        date:'29th Nov 2023'
    },
    {
        id:3,
        image: property3,
        tag:'Townter',
        title:'10 Quick Tips About Business Development',
        desc:"The most well-known dummy text is the 'Lorem Ipsum', in the 16th century.",
        date:'29th Dec 2023'
    },
    {
        id:4,
        image: property4,
        tag:'Townter',
        title:'14 Common Misconceptions About Business Development',
        desc:"The most well-known dummy text is the 'Lorem Ipsum', in the 16th century.",
        date:'13th March 2023'
    },
    {
        id:5,
        image: property5,
        tag:'Townter',
        title:'10 Things Your Competitors Can Teach You About Real Estate',
        desc:"The most well-known dummy text is the 'Lorem Ipsum', in the 16th century.",
        date:'5th May 2023'
    },
    {
        id:6,
        image: property6,
        tag:'Townter',
        title:'Why We Love Real Estate',
        desc:"The most well-known dummy text is the 'Lorem Ipsum', in the 16th century.",
        date:'19th June 2023'
    },
    {
        id:7,
        image: property7,
        tag:'Townter',
        title:'110 Quick Tips About Real Estate',
        desc:"The most well-known dummy text is the 'Lorem Ipsum', in the 16th century.",
        date:'20th June 2023'
    },
    {
        id:8,
        image: property8,
        tag:'Townter',
        title:'15 Best Blogs To Follow About Real Estate',
        desc:"The most well-known dummy text is the 'Lorem Ipsum', in the 16th century.",
        date:'31st Aug 2023'
    },
    {
        id:9,
        image: property9,
        tag:'Townter',
        title:'Using Banner Stands To Increase Trade Show Traffic',
        desc:"The most well-known dummy text is the 'Lorem Ipsum', in the 16th century.",
        date:'1st Sep 2023'
    },
]

